/* ==========================================================================
   WA Auth — WhatsApp OTP login for Shopify storefronts
   Requires window.WA_CONFIG set in theme.liquid BEFORE this file loads:
     window.WA_CONFIG = {
       apiBase: 'https://api.yourstore.com/api',
       checkoutMode: 'draft',        // 'draft' | 'native'
       countryCode: '+91',
       accountUrl: '/pages/user-account'
     };
   ========================================================================== */
(function () {
  'use strict';

  var cfg = Object.assign(
    { apiBase: '', checkoutMode: 'draft', countryCode: '+91', accountUrl: '/pages/user-account' },
    window.WA_CONFIG || {}
  );

  var TOKEN_KEY = 'wa_token';
  var CUSTOMER_KEY = 'wa_customer';

  /* ------------------------------------------------------------------ */
  /* Token + customer cache                                              */
  /* ------------------------------------------------------------------ */

  function token() {
    try { return localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
  }

  function setSession(tok, customer) {
    try {
      localStorage.setItem(TOKEN_KEY, tok);
      localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customer || {}));
    } catch (e) { /* private mode */ }
  }

  function clearSession() {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(CUSTOMER_KEY);
    } catch (e) { /* noop */ }
  }

  function customer() {
    try { return JSON.parse(localStorage.getItem(CUSTOMER_KEY) || 'null'); } catch (e) { return null; }
  }

  function isLoggedIn() { return !!token(); }

  /* ------------------------------------------------------------------ */
  /* API client                                                          */
  /* ------------------------------------------------------------------ */

  function api(path, options) {
    options = options || {};
    var headers = { 'Accept': 'application/json' };
    if (options.body !== undefined) headers['Content-Type'] = 'application/json';
    var tok = token();
    if (tok) headers['Authorization'] = 'Bearer ' + tok;

    return fetch(cfg.apiBase + path, {
      method: options.method || 'GET',
      headers: headers,
      body: options.body !== undefined ? JSON.stringify(options.body) : undefined
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (res.status === 401) {
          clearSession();
          document.dispatchEvent(new CustomEvent('wa:logout'));
        }
        if (!res.ok) {
          var err = new Error(json.message || 'Something went wrong. Please try again.');
          err.status = res.status;
          err.payload = json;
          throw err;
        }
        return json;
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* OTP modal (markup injected once, on demand)                         */
  /* ------------------------------------------------------------------ */

  var modal = null;
  var modalState = { phone: '', onSuccess: null, timer: null };

  function modalHtml() {
    return '' +
      '<div class="wa-modal-backdrop" data-wa-close></div>' +
      '<div class="wa-modal-card" role="dialog" aria-modal="true" aria-labelledby="wa-modal-title">' +
      '  <button type="button" class="wa-modal-x" data-wa-close aria-label="Close">&times;</button>' +
      '  <div class="wa-modal-badge" aria-hidden="true">' +
      '    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12.04 2c-5.46 0-9.9 4.44-9.9 9.9 0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.39a9.87 9.87 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.44 9.9-9.9 0-2.65-1.03-5.13-2.9-7A9.83 9.83 0 0 0 12.04 2Zm0 18.1a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.16 8.16 0 0 1-1.26-4.34c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.19-8.23 8.19Zm4.52-6.13c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43l-.48-.01c-.16 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.1-.23-.16-.48-.28Z"/></svg>' +
      '  </div>' +
      '  <h2 class="wa-modal-title" id="wa-modal-title">Login with WhatsApp</h2>' +
      '  <p class="wa-modal-sub" data-wa-sub>Enter your mobile number and we\u2019ll send a one-time code on WhatsApp.</p>' +
      '  <form class="wa-step" data-wa-step="phone" novalidate>' +
      '    <div class="wa-phone-row">' +
      '      <span class="wa-cc">' + escapeHtml(cfg.countryCode) + '</span>' +
      '      <input class="wa-input" type="tel" name="phone" inputmode="numeric" autocomplete="tel-national" placeholder="98765 43210" maxlength="14" required aria-label="Mobile number">' +
      '    </div>' +
      '    <button class="wa-btn" type="submit">Send code on WhatsApp</button>' +
      '  </form>' +
      '  <form class="wa-step" data-wa-step="code" hidden novalidate>' +
      '    <input class="wa-input wa-otp-input" type="text" name="otp" inputmode="numeric" autocomplete="one-time-code" placeholder="\u2022\u2022\u2022\u2022\u2022\u2022" maxlength="6" pattern="\\d{6}" required aria-label="6-digit code">' +
      '    <button class="wa-btn" type="submit">Verify &amp; login</button>' +
      '    <div class="wa-links">' +
      '      <button type="button" class="wa-link" data-wa-resend disabled>Resend code</button>' +
      '      <button type="button" class="wa-link" data-wa-change>Change number</button>' +
      '    </div>' +
      '  </form>' +
      '  <p class="wa-error" data-wa-error role="alert" hidden></p>' +
      '</div>';
  }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'wa-otp-modal';
    modal.className = 'wa-modal';
    modal.hidden = true;
    modal.innerHTML = modalHtml();
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-wa-close]')) closeLogin();
    });

    modal.querySelector('[data-wa-step="phone"]').addEventListener('submit', onPhoneSubmit);
    modal.querySelector('[data-wa-step="code"]').addEventListener('submit', onCodeSubmit);
    modal.querySelector('[data-wa-resend]').addEventListener('click', onResend);
    modal.querySelector('[data-wa-change]').addEventListener('click', function () { showStep('phone'); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeLogin();
    });

    // Shield: menu/drawer scripts often bind document-level touch and focus
    // handlers that block or steal interaction outside the drawer. Stop our
    // modal's events from bubbling to them so inputs stay clickable.
    ['touchstart', 'touchend', 'touchmove', 'pointerdown', 'pointerup',
      'mousedown', 'mouseup', 'click', 'focusin'].forEach(function (type) {
      modal.addEventListener(type, function (e) { e.stopPropagation(); });
    });

    return modal;
  }

  function showError(msg) {
    var el = modal.querySelector('[data-wa-error]');
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('.wa-btn');
    btn.disabled = busy;
    btn.classList.toggle('wa-busy', busy);
  }

  function showStep(step) {
    showError('');
    modal.querySelector('[data-wa-step="phone"]').hidden = step !== 'phone';
    modal.querySelector('[data-wa-step="code"]').hidden = step !== 'code';
    var sub = modal.querySelector('[data-wa-sub]');
    if (step === 'code') {
      sub.textContent = 'We sent a 6-digit code to ' + modalState.phone + ' on WhatsApp.';
      var input = modal.querySelector('.wa-otp-input');
      input.value = '';
      input.focus();
    } else {
      sub.textContent = 'Enter your mobile number and we\u2019ll send a one-time code on WhatsApp.';
      modal.querySelector('input[name="phone"]').focus();
    }
  }

  function startResendTimer(seconds) {
    var btn = modal.querySelector('[data-wa-resend]');
    var left = seconds || 45;
    btn.disabled = true;
    clearInterval(modalState.timer);
    function tick() {
      if (left <= 0) {
        clearInterval(modalState.timer);
        btn.disabled = false;
        btn.textContent = 'Resend code';
        return;
      }
      btn.textContent = 'Resend in ' + left + 's';
      left--;
    }
    tick();
    modalState.timer = setInterval(tick, 1000);
  }

  function onPhoneSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var raw = form.querySelector('input[name="phone"]').value.trim();
    if (!raw) return;
    var full = raw.indexOf('+') === 0 ? raw : cfg.countryCode + raw.replace(/\D/g, '');
    showError('');
    setBusy(form, true);
    api('/auth/otp/request', { method: 'POST', body: { phone: full } })
      .then(function (res) {
        modalState.phone = full;
        showStep('code');
        startResendTimer(res.resend_after || 45);
      })
      .catch(function (err) { showError(err.message); })
      .finally(function () { setBusy(form, false); });
  }

  function onResend() {
    showError('');
    api('/auth/otp/request', { method: 'POST', body: { phone: modalState.phone } })
      .then(function (res) { startResendTimer(res.resend_after || 45); })
      .catch(function (err) {
        showError(err.message);
        if (err.payload && err.payload.retry_after) startResendTimer(err.payload.retry_after);
      });
  }

  function onCodeSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var code = form.querySelector('input[name="otp"]').value.replace(/\D/g, '');
    if (code.length !== 6) { showError('Enter the 6-digit code.'); return; }
    showError('');
    setBusy(form, true);
    api('/auth/otp/verify', { method: 'POST', body: { phone: modalState.phone, otp: code } })
      .then(function (res) {
        setSession(res.token, res.customer);
        closeLogin();
        document.dispatchEvent(new CustomEvent('wa:login', { detail: res.customer }));
        if (typeof modalState.onSuccess === 'function') {
          var cb = modalState.onSuccess;
          modalState.onSuccess = null;
          cb(res.customer);
        }
      })
      .catch(function (err) { showError(err.message); })
      .finally(function () { setBusy(form, false); });
  }

  /** Close theme popups (Bootstrap modals, stray backdrops) before ours opens. */
  function closeThemeOverlays() {
    try {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.modal) {
        window.jQuery('.modal.show, .modal.in').modal('hide');
      }
      // Bootstrap's modal focus enforcement steals focus from any element
      // outside its own modal — including our inputs. Unbind it.
      if (window.jQuery) window.jQuery(document).off('focusin.bs.modal');
    } catch (err) { /* theme without bootstrap js */ }
    document.querySelectorAll('.modal-backdrop').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    document.body.classList.remove('modal-open');

    // Best-effort close for sidebar/off-canvas menus: Escape + common
    // open-state classes + a tap on a generic overlay if one exists.
    try {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    } catch (err) { /* noop */ }
    ['menu-open', 'nav-open', 'js-menu-open', 'mobile-menu-open', 'drawer-open',
      'sidebar-open', 'offcanvas-open', 'menu--is-open'].forEach(function (cls) {
      document.body.classList.remove(cls);
      document.documentElement.classList.remove(cls);
    });
    var overlay = document.querySelector('.drawer-overlay, .menu-overlay, .mobile-nav-overlay, .site-overlay, .nav-overlay');
    if (overlay) { try { overlay.click(); } catch (err) { /* noop */ } }

    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
  }

  /*
   * Focus isolation: drawers and menus commonly run a focus trap that pulls
   * focus back to themselves whenever it lands elsewhere — which makes our
   * inputs impossible to type in (buttons still "work" because a click needs
   * no sustained focus). Marking every other top-level element `inert` makes
   * those .focus() calls no-ops, so our field keeps focus.
   */
  var inertedEls = [];

  function applyInert() {
    inertedEls = [];
    Array.prototype.slice.call(document.body.children).forEach(function (el) {
      if (el === modal || el.inert) return;
      try { el.inert = true; inertedEls.push(el); } catch (err) { /* unsupported */ }
    });
  }

  function releaseInert() {
    inertedEls.forEach(function (el) {
      try { el.inert = false; } catch (err) { /* noop */ }
    });
    inertedEls = [];
  }

  function openLogin(options) {
    options = options || {};
    ensureModal();
    closeThemeOverlays();
    // Always re-anchor as the LAST child of <body>: wins same-z stacking and
    // escapes transformed wrappers that break position:fixed on mobile.
    document.body.appendChild(modal);
    applyInert();
    modalState.onSuccess = options.onSuccess || null;
    modal.hidden = false;
    document.documentElement.classList.add('wa-modal-open');
    document.body.classList.add('wa-modal-open');
    showStep('phone');
  }

  function closeLogin() {
    if (!modal) return;
    releaseInert();
    modal.hidden = true;
    document.documentElement.classList.remove('wa-modal-open');
    document.body.classList.remove('wa-modal-open');
    clearInterval(modalState.timer);
  }

  function requireLogin(callback) {
    if (isLoggedIn()) { callback(); return; }
    openLogin({ onSuccess: function () { callback(); } });
  }

  /* ------------------------------------------------------------------ */
  /* Checkout gate                                                       */
  /* ------------------------------------------------------------------ */

  function goToCheckout() {
    if (cfg.checkoutMode !== 'draft') {
      window.location.href = '/checkout';
      return;
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          window.location.href = '/cart';
          return;
        }
        var items = cart.items.map(function (item) {
          /*
           * Do NOT copy Shopify cart discount allocations into the Draft Order.
           *
           * The WhatsApp/Draft Order checkout uses current product prices only.
           * This prevents stale/previous automatic discounts from being replayed
           * for a customer after a promotion has been disabled.
           */
          var line = {
            variant_id: item.variant_id || item.id,
            quantity: item.quantity,
            line_price: (item.original_line_price || item.line_price || 0) / 100
          };

          // Line properties (bundle picks, personalisation) — keep them on the
          // order. Shopify hides keys starting with "_" from the customer.
          var props = item.properties || {};
          var attributes = Object.keys(props)
            .filter(function (key) { return props[key] !== null && props[key] !== ''; })
            .map(function (key) { return { key: key, value: String(props[key]) }; });

          if (attributes.length) line.properties = attributes;

          return line;
        });
        return api('/checkout/prepare', { method: 'POST', body: { items: items, note: cart.note || '' } })
          .then(function (res) { window.location.href = res.invoice_url; });
      })
      .catch(function (err) {
        alert(err.message || 'Could not start checkout. Please try again.');
      });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], [data-wa-checkout]'
    );
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    requireLogin(goToCheckout);
  }, true);

  /* ------------------------------------------------------------------ */
  /* Buy Now: [data-wa-buynow] inside (or near) a product form.          */
  /* Reads variant + qty at click time, so variant switches are safe.    */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wa-buynow]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var variantId = parseInt((variantInput && variantInput.value) || btn.getAttribute('data-variant-id') || '', 10);
    var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    if (!variantId) { alert('Please select an option first.'); return; }

    requireLogin(function () {
      btn.disabled = true;
      api('/checkout/prepare', { method: 'POST', body: { items: [{ variant_id: variantId, quantity: quantity }] } })
        .then(function (res) { window.location.href = res.invoice_url; })
        .catch(function (err) {
          alert(err.message || 'Could not start checkout.');
          btn.disabled = false;
        });
    });
  }, true);

  /* Gated "Buy it now": place <button data-wa-buynow> inside the product
     form. Checks out ONLY the selected variant via a draft order. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wa-buynow]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    var idEl = form && form.querySelector('[name="id"]');
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var variantId = idEl ? parseInt(idEl.value, 10) : 0;
    var quantity = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    if (!variantId) { alert('Please select an option first.'); return; }
    requireLogin(function () {
      btn.disabled = true;
      var proceed;
      if (cfg.checkoutMode === 'draft') {
        proceed = api('/checkout/prepare', {
          method: 'POST',
          body: { items: [{ variant_id: variantId, quantity: quantity }] }
        }).then(function (res) { window.location.href = res.invoice_url; });
      } else {
        proceed = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        }).then(function () { window.location.href = '/checkout'; });
      }
      proceed.catch(function (err) {
        alert(err.message || 'Could not start checkout. Please try again.');
        btn.disabled = false;
      });
    });
  });

  /* ------------------------------------------------------------------ */
  /* Wishlist buttons on product pages: [data-wa-wishlist][data-handle]  */
  /* ------------------------------------------------------------------ */

  var wishlistCache = null;

  function wishlistList() {
    if (wishlistCache) return Promise.resolve(wishlistCache);
    return api('/wishlist').then(function (res) {
      wishlistCache = res.items || [];
      return wishlistCache;
    });
  }

  function wishlistSave(items) {
    wishlistCache = items.slice();
    return api('/wishlist', { method: 'PUT', body: { items: items } });
  }

  function wishlistToggle(handle) {
    return wishlistList().then(function (items) {
      var next = items.indexOf(handle) === -1
        ? items.concat([handle])
        : items.filter(function (h) { return h !== handle; });
      return wishlistSave(next).then(function () { return next.indexOf(handle) !== -1; });
    });
  }

  function paintWishlistButtons() {
    var buttons = document.querySelectorAll('[data-wa-wishlist][data-handle]');
    if (!buttons.length || !isLoggedIn()) return;
    wishlistList().then(function (items) {
      buttons.forEach(function (btn) {
        var on = items.indexOf(btn.getAttribute('data-handle')) !== -1;
        btn.classList.toggle('wa-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }).catch(function () { /* silent */ });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wa-wishlist][data-handle]');
    if (!btn) return;
    e.preventDefault();
    requireLogin(function () {
      btn.disabled = true;
      wishlistToggle(btn.getAttribute('data-handle'))
        .then(function (on) {
          btn.classList.toggle('wa-on', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        })
        .catch(function (err) { alert(err.message); })
        .finally(function () { btn.disabled = false; });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintWishlistButtons);
  } else {
    paintWishlistButtons();
  }
  document.addEventListener('wa:login', paintWishlistButtons);

  /* ------------------------------------------------------------------ */
  /* Helpers + public API                                                */
  /* ------------------------------------------------------------------ */

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function logout() {
    var done = function () {
      clearSession();
      wishlistCache = null;
      document.dispatchEvent(new CustomEvent('wa:logout'));
    };
    return api('/auth/logout', { method: 'POST' }).then(done).catch(done);
  }

  window.WAAuth = {
    config: cfg,
    api: api,
    isLoggedIn: isLoggedIn,
    customer: customer,
    openLogin: openLogin,
    closeLogin: closeLogin,
    requireLogin: requireLogin,
    goToCheckout: goToCheckout,
    logout: logout,
    escapeHtml: escapeHtml,
    wishlist: { list: wishlistList, toggle: wishlistToggle }
  };
})();